import React, { useEffect, useState } from "react";
import useAlertDialog from "../../../hooks/useAlertDialog";
import { AlertType } from "../../../hooks/common/useAttachAlertDialog";
import { updatePartnerReviews } from "../../../../services/PartnerService";

export default function useUpdateReviewsPartner(props: { reload: () => void }) {
	const { openAlertDialog } = useAlertDialog();

	const loadUpdateReviews = async (partnerId: string, reviews: any[]) => {
		try {
			await updatePartnerReviews(partnerId, reviews);
			openAlertDialog?.(AlertType.Success, "Reviews updated successfully!", () => {});
			props.reload();
		} catch (err: any) {
			console.error(err);
			openAlertDialog?.(AlertType.Fail, err?.response?.data?.message || "An error has occurred!", () => {});
		}
	};

	return {
		loadUpdateReviews,
	};
}

